export default function Title() {
  return (
    <h1 className='pl-2 mb-8 font-medium text-5xl text-gray-800 text-center'>
      Web Accessibility Validator
    </h1>
  );
}
